import LogUtils from "./LogUtils";

class MsgUtils {

  MSGS = {
    INVALID_ACCESS_CREDENTIALS: "Credenciais de acesso inválidas",
    INVALID_EMAIL: "Por favor utilize um email válido",
    INVALID_CODE: "Código de acesso inválido",
    FAILED_TO_PERFORM_OPERATION: "Houve uma falha ao realizar esta operação, por favor tente mais tarde",
    PASSWORD_RULES: "Sua senha foi criada de acordo com as seguintes regras: pelo menos 8 caracteres; 1 letra maiúscula; 1 letra minúscula; um dos seguintes caracteres especiais: !@#$&_*; 1 número;",
    NEW_PASSWORD_RULES: "Sua senha deve ser criada de acordo com as seguintes regras: pelo menos 8 caracteres; 1 letra maiúscula; 1 letra minúscula; um dos seguintes caracteres especiais: !@#$&_*; 1 número;",
    SUCCESSFULLY_LOGGED_IN: "Login realizado com sucesso",
    UNAUTHORIZED_USER: "O seu usuário não está autorizado a utilizar o app do agente",
    UNAUTHORIZED_USER_TYPE: "O seu tipo de usuário não está autorizado o app do agente",

    SUCCESSFULLY_SENT_INSTRUCTIONS_RECOVER_PASSWORD: "Enviamos instruções para a recuperação de sua senha para o email cadastrado.",
    SUCCESSFULLY_UPDATED_PASSWORD: "Sua senha foi atualizada com sucesso",
    INVALID_EMAIL_USER_NOT_FOUND: "Não encontramos um usuário cadastrado com o email informado",
    UNABLE_SEND_INSTRUCTIONS: "Não foi possível enviar o email com instruções para a recuperação da senha, por favor tente mais tarde",
    UNABLE_RESET_PASSWORD: "Não foi possível redefinir sua senha, por favor tente mais tarde",
    UNABLE_TO_LOGIN: "Não foi possível fazer o login, por favor tente mais tarde",
    UNABLED_TO_LOGOUT: "Não foi possível fazer o logout",
    SUCCESSFULLY_LOGGED_OUT: "Logout realizado com sucesso",

    FAILED_TO_CREATE_USER: "Não foi possível criar o novo usuário",
    FAILED_TO_UPDATE_USER: "Não foi possível atualizar o usuário",
    FAILED_TO_DELETE_USER: "Não foi possível deletar o usuário",
    SUCCESSFULLY_CREATED_USER: "Usuário criado com sucesso",
    SUCCESSFULLY_UPDATED_USER: "Usuário atualizado com sucesso",
    SUCCESSFULLY_DELETED_USER: "Usuário deletado com sucesso",
    ARE_YOU_SURE_WANNA_DELETE_USER: "Você realmente deseja deletar este usuário? Se bem sucedida, esta ação não poderá ser desfeita",
    UNABLE_PERFORM_OPERATION: "Não foi possível exibir as informações solicitadas.",

    MSG_VECTOR_FOCUS_SERIOUSNESS_MILD: "É bom dar uma olhada.",
    MSG_VECTOR_FOCUS_SERIOUSNESS_MODERATE: "A situação não está legal.",
    MSG_VECTOR_FOCUS_SERIOUSNESS_HARD: "Este foco deve ser resolvido o mais rápido possível!",
  }
  TXTS = {
    LABEL_USER_TYPES: {
      USER: "Usuário comum",
      PLATFORM_USER: "Usuário da plataforma",
      ADMIN: "Administrador",
      AGENTS_MANAGER: "Gestor de agente",
      AGENT: "Agente",
      RESEARCHER: "Pesquisador",
      POPULATION: "População"
    },
    DENOUNCE_STATUS: {
      OPENED: "Não iniciado",
      IN_PROGRESS: "Em progresso",
      CLOSED: "Finalizado"
    }
  }

  constructor() {
    this.logUtils = new LogUtils();
  }

  getTxts() {
    return this.TXTS;
  }

  getMsgs() {
    return this.MSGS;
  }

}

export default MsgUtils;